module.exports = __webpack_public_path__ + "assets/img/block-hover-3d6bd9c6.png";